import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TransactionsRoutingModule } from './transactions-routing.module';
import { AccountingTransactionsListComponent } from './pages/accounting-transactions-list/accounting-transactions-list.component';
import { AddTransactionComponent, TestContent } from './components/add-transaction/add-transaction.component';
import { CardSharedModule } from '../client/shared/card-shared.module';
import { IntakeModule } from '../intake/intake.module';
import { DraggableDirective } from './draggable.directive';
import { SharedModule } from '../../shared/shared.module';
import { TransactionNotesManagerComponent } from './components/transaction-notes-manager/transaction-notes-manager.component';

@NgModule({
  imports: [
    CommonModule,
    TransactionsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    CardSharedModule,
    IntakeModule,
    SharedModule
  ],
  declarations: [AccountingTransactionsListComponent, AddTransactionComponent, TestContent, DraggableDirective, TransactionNotesManagerComponent],
  entryComponents: [
    AddTransactionComponent,
    TestContent,
    TransactionNotesManagerComponent
  ]
})
export class TransactionsModule { }
